import { Phone } from "lucide-react";

interface CrisisBannerProps {
  variant?: "light" | "dark";
}

const CrisisBanner = ({ variant = "light" }: CrisisBannerProps) => {
  const isDark = variant === "dark";

  return (
    <div className={`rounded-xl border px-5 py-4 sm:px-6 ${isDark ? "border-primary-foreground/15 bg-primary-foreground/5" : "border-accent/20 bg-accent/5"}`}>
      <div className="flex flex-col items-center gap-2 text-center sm:flex-row sm:text-left">
        <Phone className="h-4 w-4 shrink-0 text-accent" strokeWidth={2} />
        <p className={`text-sm ${isDark ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
          <span className={`font-semibold ${isDark ? "text-primary-foreground" : "text-foreground"}`}>If you or someone you know is in crisis, call or text </span>
          <a href="tel:988" className="font-bold text-accent underline underline-offset-2 hover:text-accent-glow transition-colors">988</a>
          <span className={`font-semibold ${isDark ? "text-primary-foreground" : "text-foreground"}`}> (Suicide &amp; Crisis Lifeline) or text HOME to </span>
          <a href="sms:741741" className="font-bold text-accent underline underline-offset-2 hover:text-accent-glow transition-colors">741741</a>.
        </p>
      </div>
    </div>
  );
};

export default CrisisBanner;
